import { create } from 'zustand';

interface BabyState {
  selectedBabyId: string | null;
  setSelectedBabyId: (babyId: string | null) => void;
}

export const useBabyStore = create<BabyState>((set: (fn: (state: BabyState) => BabyState) => void) => ({
  selectedBabyId: null,
  setSelectedBabyId: (babyId: string | null) => set((state) => ({ ...state, selectedBabyId: babyId })),
}));
